/**
 * Application configuration.
 *
 * At runtime, a config.js script is loaded for custom application
 * configuration. The values below are the defaults and config.js is empty
 * unless overwritten. When the script is overwritten, it should assign values
 * to `window` properties as needed.
 */

// Token used by the geocoder. Set to null to disable the geocoder.
export const MAPBOX_ACCESS_TOKEN =
  import.meta.env.VITE_MAPBOX_TOKEN ||
  'pk.eyJ1IjoicGxhbmV0IiwiYSI6ImNrOTBhYWk3cDBoemszbG11bHQ1enVodjMifQ.yv8qxqOEs2m2ndD4F-c-lA';

// Optional URL for API endpoint. The mosaic listing is assumed to be at
// ${API_HOSTNAME}/mosaic/experimental/mosaics
export const API_HOSTNAME = 'https://api.planet.com';

// The base path for the mosaic listing in the API, as mentioned above
export const API_MOSAICS_BASE_PATH = `${API_HOSTNAME}/basemaps/v1/mosaics`;

// URL template for a tile set to show under mosaics
export const BASE_LAYER_STYLES = {
  dark: 'mapbox://styles/planet/ck8yzkkra05tv1ip9os6pmi1e',
  light: 'mapbox://styles/planet/clu7p4c73008l01ra8lzr9qlo',
};

// URL template for a tile set to show over mosaics. Set to null for none.
export const LABEL_STYLES = {
  dark: 'mapbox://styles/planet/ck9qfizat2wz81ip84e3ac018',
  light: 'mapbox://styles/planet/clu7p6so002f401ptf4b0d76g',
};

export const LD_CLIENTSIDE_ID =
  import.meta.env.VITE_LD_CLIENTSIDE_ID ?? '662b9f49db0cc60fb29d0302';
